export default {
	//api_url: 'http://localhost:9500/api/',
	//api_url: 'http://tpl.xbees.in/api/',
	//api_url: 'https://tpl-kavach-api.xbees.in/api/',
	//api_url: 'http://localhost:9500/api/',
	api_url: window.location.href.indexOf("https://tplapp.xbees.in")>-1?"https://tpl.xbees.in/api/":window.location.href.indexOf("preprodtplapp.xbees.in")>-1?"https://preprodtpl.xbees.in/api/":window.location.href.indexOf("stagetplapp.xbees.in/")>-1?"https://tplstage.xbees.in/api/":"http://localhost:9500/api/",
	local_printer_api_url: 'http://localhost:7500/api/',
	kavachURL: window.location.href.indexOf("https://tplapp.xbees.in")>-1?"https://auth.xbees.in":"https://stage-auth.xbees.in",
	locale:[{
			value: 'en',
			text: 'English (en)'
		},
		{
			value: 'hi',
			text: 'हिन्दी (hi)'
		},
		{
			value: 'id',
			text: 'bahasa (id)'
		}
	]
}



// WEBPACK FOOTER //
// ./src/constants.js